<template>
  <v-os-popup title="旧机交易方式" v-model="show" @close="close" container="body">
    <div role="listbox">
      <div
        v-for="trade in tradeList"
        :key="trade.id"
        role="option"
        :aria-label="
          trade.label +
          '，' +
          trade.tip +
          (trade.type == info.selected ? '，当前选项已选中' : '，当前选项未选中，点按两次即可选中')
        "
        @click="select(trade.type)"
        :class="{ 'custom-dark': customDark }"
        class="trade-item"
      >
        <v-checkbox class="checkbox" :value="trade.type == info.selected"></v-checkbox>
        <!-- <v-icon name="selected" class="checkbox" v-if="trade.type == info.selected"></v-icon>
        <v-icon name="unselected" class="checkbox" v-else></v-icon> -->
        <div class="trade-main">
          <p class="label">{{ trade.label }}</p>
          <p class="tip">{{ trade.tip }}</p>
        </div>
      </div>
    </div>
  </v-os-popup>
</template>
<script>
import CONSTANT from '@/views/product/recycle/constant'
export default {
  name: 'TradeTypePopUp',
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          isShow: false,
          enableList: [],
          selected: 1
        }
      }
    },
    show: {
      type: Boolean,
      default: false
    },
    customDark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tradeList() {
      return (this.info?.enableList || []).map(type => {
        return CONSTANT.OLD_TRADE_TYPE_OBJ[type]
      })
    }
  },
  data() {
    return {
      CONSTANT
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    select(tradeType) {
      if (tradeType == this.info.selected) {
        this.$emit('close')
      } else {
        this.$emit('select', tradeType)
        this.$emit('close')
      }
    }
  },
  created() {},
  mounted() {}
}
</script>
<style lang="scss" scoped>
.listbox {
  margin-top: 3px;
}
.trade-item {
  width: 100%;
  background: #f9f9f9;
  border-radius: 24px;
  margin-bottom: 30px;
  padding: 40px 48px 42px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  &.custom-dark {
    @include bgColor(#f9f9f9, rgba(255, 255, 255, 0.1));
    .label {
      @include fontColor(#000, rgba(255, 255, 255, 0.9));
    }
    .tip {
      @include fontColor(#888888, rgba(255, 255, 255, 0.5));
    }
  }
  &.disabled {
  }
  .label {
    font-size: 42px;
    line-height: 58px;
    @include os-font-weight(42, 50);
    color: #000000;
  }
  .tip {
    margin-top: 16px;
    font-size: 36px;
    line-height: 48px;
    @include os-font-weight(36, 40);
    color: #888888;
  }
  .checkbox {
    width: 54px;
    height: 54px;
    flex-shrink: 0;
    margin-right: 30px;
  }
}
</style>
